export function interopDefault(mod) {
    // @ts-ignore
    return mod.default || mod;
}

//# sourceMappingURL=interop-default.js.map